import { externalLaunchContextAtom } from '@/atoms/externalLaunchAuthAtoms';
import { useSessionListVersion } from '@/composition/hosts/session/session-list/useSessionListVersion';
import { useIsFhirAuth } from '@/hooks/integrations/useIsFhirAuth';
import { useAtomValue } from 'jotai';
import dynamic from 'next/dynamic';

const SessionsBar = dynamic(
  () => import('@/components/layout/Navigation/sessions/side-bar')
);
const SessionsBarV2 = dynamic(
  () => import('@/features/upcomingSessionTab/components/session-bar-v2')
);

const ConsolidatedSessionsBar = dynamic(
  () => import('@/features/consolidatedSessionsList/components/sessionBar')
);

/**
 * Sessions panel content for mobile sidebar.
 * Conditionally renders ConsolidatedSessionsBar, SessionsBarV2, or legacy SessionsBar based on feature flags.
 * Hidden when launched from any EHR integration (Epic FHIR or generic EHR like Healthdirect).
 */
export const SessionsPanelContent = () => {
  const isFhirAuth = useIsFhirAuth();
  const isGenericEhrLaunch = Boolean(
    useAtomValue(externalLaunchContextAtom)?.ehrProvider
  );
  const isEhrLaunch = isFhirAuth || isGenericEhrLaunch;
  const sessionListVersion = useSessionListVersion();

  if (isEhrLaunch) {
    return null;
  }

  if (sessionListVersion === 'consolidated') {
    return <ConsolidatedSessionsBar />;
  }
  if (sessionListVersion === 'v2') {
    return <SessionsBarV2 />;
  }
  return <SessionsBar />;
};
